<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">

        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>

      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="17">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            class="table-xs"
            :data="tableData"
            style="width: 100%"
            width="100%"
            :height="Height"
          >
            <el-table-column
              label="Zaman"
              prop="Tarih"
              width="250">
            </el-table-column>
            <el-table-column
              label="Telefon"
              prop="Telefon"
              width="150">
            </el-table-column>
            <el-table-column
              label="Senaryo"
              prop="Senaryo">
            </el-table-column>
            <el-table-column
              label="Bekleme Süresi"
              prop="Bekleme"
              width="100">
            </el-table-column>
            <el-table-column
              label="Dahili"
              prop="Dahili"
              width="100">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import Yukleniyor from "../../components/Doc/Yukleniyor";

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));


export default {
  components: {Yukleniyor},
  data() {
    return {
      Height: 0,
      lo: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'Santral Raporu',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Tarih: [],
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      MakbuzDetayModal: false,
      mNo: null,
      tableData: [],
      ExcelData: [],
      PosListe: [],
      tableDisplay: false,
      AltToplam: []
    }
  },
  methods: {

    Excel(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 15},
        {wch: 15},
        {wch: 40},
        {wch: 13},
        {wch: 15},
      ];

      wb.Props = {
        Title: this.Sayfa.Adi,
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Sayfa.Adi,
      };
      XLSX.utils.book_append_sheet(wb, ws, this.DefterTur);
      XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");
    },
    Yazdir() {
      window.print();
    },
    Getir() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'raporlama/santral/'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.Liste;
                this.ExcelData = response.ExcelData;
                this.SantalDurumu = response.SantalDurumu;

                if (this.tableData)
                  this.tableDisplay = true;
                else
                  this.$message.error("Kayıt Bulunamadı");

                this.Height = window.innerHeight - 180
              } else {

                this.$alert("Telefon numaranızı arayan kat maliklerine İsimleriyle hitap ederek detaylı borç bilgisi verebilir, online işlem şifresi verebilir ve çağrı trafiğini izleyebilirsiniz.<br>Bu sayede borç bilgisi için zaman kaybınız olmaz. Kişi ekranlarında kişilerin ne zaman aradıklarını detaylı olarak görebilirsiniz.", 'Sanral Entegrasyonu bulunamadı', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: 'Şimdi Entegre Ol',
                }).then(() => {
                  window.open('https://api.whatsapp.com/send?phone=908508403806&text=Merhaba,%20Santral%20Entegrasyonu%20i%C3%A7in%20g%C3%B6r%C3%BC%C5%9Fmek%20istiyorum.', '_blank');
                });

              }
            })
        }
      })
    },
    SayfaYukle() {
    },

  },
  created() {
    //this.SayfaYukle();
    var Gun = new Date();
    //this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    //this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    this.Form.Tarih[0] = new Date();
    this.Form.Tarih[1] = new Date();
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/santral.vue